"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelCatalogueServiceDefinition = void 0;
const registerFaModelCatalogue_1 = require("./registerFaModelCatalogue");
const getFunctionModelCatalogueUrl_1 = require("./getFunctionModelCatalogueUrl");
const v1_1 = require("./v1");
exports.modelCatalogueServiceDefinition = {
    id: 'model-catalogue-service',
    dependencies: {
        featureServices: {
            'featureapp-service': '^1.0.0',
            'user-interaction-service': '^2.1.0',
            'service-config-endpoint-provider': '^1.0.0',
            'locale-service': '^1.0.0',
            'data-version-service': '^1.0.0',
            'showroom-navigation': '^1.1.0',
        },
    },
    optionalDependencies: {
        featureServices: {
            's2:logger': '^1.0.0',
        },
    },
    create: ({ featureServices }) => {
        const { 'featureapp-service': featureappService, 'user-interaction-service': userInteractionService, 's2:logger': logger, } = featureServices;
        const actionId = 'cms--fa-model-catalogue';
        const emptyFeatureService = {
            '1.0.0': () => ({
                featureService: {},
            }),
        };
        const featureAppConfig = featureappService.featureAppConfigurations['model-catalogue'];
        if (!featureAppConfig) {
            logger.warn(`Model catalogue is not registered`);
            return emptyFeatureService;
        }
        const { baseUrl: modelCatalogueBaseUrl, apiKey } = featureAppConfig;
        if (!modelCatalogueBaseUrl || !apiKey) {
            logger.warn(`Could not find base URL or api key for model catalogue feature app.
           Check if model catalogue FA is registered correctly under name model-catalogue and base url and api key are provided`);
            return emptyFeatureService;
        }
        const getModelCatalogueUrl = (0, getFunctionModelCatalogueUrl_1.getFunctionModelCatalogueUrl)(featureServices);
        // register user interaction with link to model catalogue backend
        (0, registerFaModelCatalogue_1.registerFaModelCatalogue)({
            userInteractionService,
            actionId,
            modelCatalogueUrl: getModelCatalogueUrl(),
        });
        return {
            '1.0.0': () => ({
                featureService: new v1_1.ModelCatalogueServiceV1Impl(getModelCatalogueUrl),
            }),
        };
    },
};
__exportStar(require("./v1/types"), exports);
//# sourceMappingURL=index.js.map